// Color scheme
export const COLORS = {
  primary: '#00B0ED',      // Blue
  secondary: '#D7D8DB',    // Light Grey
  dark: '#002033',         // Dark Blue/Navy
  white: '#FFFFFF',
  lightGrey: '#F5F5F7',
  darkGrey: '#333333',
};

// Layout
export const BREAKPOINTS = {
  mobile: '576px',
  tablet: '768px',
  desktop: '1024px',
  wide: '1200px',
};

// Typography
export const FONTS = {
  heading: "'Montserrat', sans-serif",
  body: "'Open Sans', sans-serif",
};

// Spacing
export const SPACING = {
  xs: '0.25rem',
  sm: '0.5rem',
  md: '1rem',
  lg: '1.5rem',
  xl: '2rem',
  xxl: '3rem',
}; 